// extracted by mini-css-extract-plugin
module.exports = {"--space-1x":"8px","space1X":"8px","root":"root-7ehxuy6sd8","spin":"spin-2GE3Gf54qD"};